import React from "react";

export default function DateParagraph(date, content) {
  return (
    <div className="flex gap-[45px] text-left">
      <p className="text-body">{date}</p>
      <p className="text-body whitespace-pre-line text-[#333333]">
        {content}
      </p>
    </div>
  );
}
